import React from 'react'
import axios from 'axios'
import queryString from 'qs'

class LoginCallback extends React.Component {
  state = {
    isSend: false
  }

  componentDidMount() {
    const query = queryString.parse(this.props.location.search.replace('?', ''))

    if(query.code) {
        this.getAccessToken(query.code)
    }
  }

  getAccessToken = (code) => {
    const sso = `/sso/grant?code=${code}&_=${new Date().getTime()}`
    axios(sso)
    .then(value => {
      localStorage.setItem('sso_access_token', value.data.access_token)
      this.props.history.replace('/')
    })
    .catch(err => {
      this.props.history.replace('/', err)
    })
  }

  render() {
    return <div style={{padding: 16}}>กำลังโหลด...</div>
  }
}


export default LoginCallback



// WEBPACK FOOTER //
// ./src/containers/Auth/callback.js